import { z } from "zod";

import { addLabelConfigurationSchema } from "./add-label-configuration";

export const addClosingConfigurationSchema = z.object({
	closingType: z.string().optional(),
	tapeLocation: z.string().optional(),
	lidFlute: z.string().optional(),
	lidBrand: z.string().optional(),
	labels: z.array(addLabelConfigurationSchema).optional(),
});
export type AddClosingConfiguration = z.infer<typeof addClosingConfigurationSchema>;
